module.exports = __webpack_public_path__ + "static/tempus-DND3_FnP-beba901132904d59657a221bd0f97b0a.jpg";